var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSetting2Active({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "vuesax/linear/setting-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "vuesax/linear/setting-2_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "setting-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M1.66669 10.7338V9.26718C1.66669 8.40052 2.37502 7.68385 3.25002 7.68385C4.75835 7.68385 5.37502 6.61718 4.61669 5.30885C4.18335 4.55885 4.44169 3.58385 5.20002 3.15052L6.64169 2.32552C7.30002 1.93385 8.15002 2.16718 8.54169 2.82552L8.63335 2.98385C9.38335 4.29218 10.6167 4.29218 11.375 2.98385L11.4667 2.82552C11.8584 2.16718 12.7084 1.93385 13.3667 2.32552L14.8084 3.15052C15.5667 3.58385 15.825 4.55885 15.3917 5.30885C14.6334 6.61718 15.25 7.68385 16.7584 7.68385C17.625 7.68385 18.3417 8.39218 18.3417 9.26718V10.7338C18.3417 11.6005 17.6334 12.3172 16.7584 12.3172C15.25 12.3172 14.6334 13.3838 15.3917 14.6922C15.825 15.4505 15.5667 16.4172 14.8084 16.8505L13.3667 17.6755C12.7084 18.0672 11.8584 17.8339 11.4667 17.1755L11.375 17.0172C10.625 15.7088 9.39169 15.7088 8.63335 17.0172L8.54169 17.1755C8.15002 17.8339 7.30002 18.0672 6.64169 17.6755L5.20002 16.8505C4.44169 16.4172 4.18335 15.4422 4.61669 14.6922C5.37502 13.3838 4.75835 12.3172 3.25002 12.3172C2.37502 12.3172 1.66669 11.6005 1.66669 10.7338Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M10 12.5C11.3807 12.5 12.5 11.3807 12.5 10C12.5 8.61929 11.3807 7.5 10 7.5C8.61929 7.5 7.5 8.61929 7.5 10C7.5 11.3807 8.61929 12.5 10 12.5Z",
    fill: "white"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSetting2Active);
export default __webpack_public_path__ + "static/media/setting-2-active.b5bfec9b5ccda182ae56362bad32e4eb.svg";
export { ForwardRef as ReactComponent };